export default __webpack_public_path__ + "static/media/file-icon.b5fe51de.svg";